<template>
  <div class="bg">
    <div class="bc">
      <div class="top_space"/>
      <img class="title_img" loading="lazy" alt/>
      <div class="img_space"/>

      <div class="row no-gutters justify-content-between  icon_area">

        <div v-for="(item,index) in itemList" class="col-4 item">
          <div class="row no-gutters align-items-center item_row">
            <img class="icon" :src="item.icon" loading="lazy" :alt="item.text"/>
            <div class="row no-gutters align-items-center">
              <div class="index_text">{{ index + 1 }}</div>
              <div class="icon_text" v-html="formattedText(item.text)"/>
            </div>
          </div>

        </div>

      </div>


      <div class="down_space"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "Join_3",
  data() {
    return {
      itemList: [
        {
          icon: "/img/image/join/join_1_icon.png",
          text: "填寫加盟表單",
        }, {
          icon: "/img/image/join/join_2_icon.png",
          text: "專人邀約說明",
        }, {
          icon: "/img/image/join/join_3_icon.png",
          text: "填寫加盟申請書",
        },
        {
          icon: "/img/image/join/join_4_icon.png",
          text: "加盟資格審核",
        }, {
          icon: "/img/image/join/join_5_icon.png",
          text: "簽訂加盟預約書",
        }, {
          icon: "/img/image/join/join_6_icon.png",
          text: "總部教育訓練",
        },
        {
          icon: "/img/image/join/join_7_icon.png",
          text: "簽訂合約和\n店面租約",
        }, {
          icon: "/img/image/join/join_8_icon.png",
          text: "店面設計\n施工裝潢驗收",
        }, {
          icon: "/img/image/join/join_9_icon.png",
          text: "門市試營運",
        },
        {
          icon: "/img/image/join/join_10_icon.png",
          text: "門市開幕",
        }, {
          icon: "/img/image/join/join_11_icon.png",
          text: "總部協助\n行銷曝光",
        }, {
          icon: "/img/image/join/join_12_icon.png",
          text: "正式營運",
        },
      ],
    };
  },
  methods: {
    formattedText(text) {
      return text.replace(/\n/g, '<br>');
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  background-image: url('/img/image/background/bg_s7_1.png');
  background-size: cover; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: no-repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
  text-align: center;
}


.top_space, .down_space {
  height: 40px;
}

.title_img {
  width: 300px;
  height: auto;
  content: url('/img/image/join/process.png');
}

@media (max-width: 768px) {
  .title_img {
    width: 40vw;
  }
}

@media (max-width: 360px) {
  .title_img {
    width: 155px;
  }
}

.img_space {
  height: 24px;
}


.icon_area {
  width: 928px;
  margin: 0 auto;
}

@media (max-width: 992px) {
  .icon_area {
    width: 635px;
  }
}

@media (max-width: 768px) {
  .icon_area {
    width: 530px;
  }
}
@media (max-width: 576px) {
  .icon_area {
    width: 400px;
  }
}
@media (max-width: 425px) {
  .icon_area {
    width: 88vw;
  }
}

@media (max-width: 375px) {
  .icon_area {
    width: 90vw;
  }
}


.item {
  margin-bottom: 32px;
  padding-right: 0;
  padding-left: 0;
  position: relative;
  width: 100%;
  min-height: 1px;
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

@media (max-width: 992px) {
  .item {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

.item_row {

}

@media (max-width: 576px) {
  .item_row {
    flex-direction: column;
  }
}


.icon {
  width: 64px;
  height: 64px;
  margin-right: 16px;
}

@media (max-width: 768px) {
  .icon {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 360px) {
  .icon {
    width: 42px;
    height: 42px;
  }
}

@media (max-width: 576px) {
  .icon {
    margin-right: 0;
    margin-bottom: 8px;
  }
}


.index_text {
  font-family: Noto Sans TC;
  font-weight: 700;
  margin-right: 8px;
}

.index_text, .icon_text {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-align: left;
  color: #FFFFFF;
}


@media (max-width: 768px) {
  .index_text, .icon_text {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .index_text, .icon_text {
    font-size: 18px;
  }
}

@media (max-width: 425px) {
  .index_text, .icon_text {
    font-size: 16px;
  }
}


@media (max-width: 320px) {
  .index_text, .icon_text {
    font-size: 12px;
  }
}

</style>
